import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Bell, Check } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/notifications").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="eyebrow">Avisos</div>
          <h1 className="font-heading text-5xl mt-2">Notificações</h1>
        </div>
        <button onClick={markAll} className="pill-btn pill-ghost !py-2 !px-4" data-testid="mark-all-read">
          <Check className="w-4 h-4"/> Marcar todas como lidas
        </button>
      </div>

      {loading ? (
        <div className="text-[var(--ink-soft)]">A carregar…</div>
      ) : items.length === 0 ? (
        <div className="card-surface p-10 text-center">
          <Bell className="w-8 h-8 mx-auto text-[var(--ink-soft)]"/>
          <p className="text-[var(--ink-soft)] mt-2">Sem notificações por agora.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} className={`card-surface p-5 ${!n.read ? "border-[var(--forest)]" : ""}`} data-testid={`notif-${n.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="font-semibold text-[var(--ink)]">{n.title}</div>
                  <p className="text-sm text-[var(--ink-soft)] mt-1">{n.message}</p>
                  {n.link && <Link to={n.link} className="text-xs text-[var(--forest)] underline mt-2 inline-block">Abrir</Link>}
                </div>
                {!n.read && <span className="chip chip-terra">Novo</span>}
              </div>
              <div className="mt-3 text-[11px] text-[var(--ink-soft)]">{new Date(n.created_at).toLocaleString("pt-PT")}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
